import fs from 'node:fs'
import type { SnapshotManifest } from '@cli-types/core-engine/snapshots.js'
import { manifestPath } from './manifest-path.js'

export function loadManifest(cwd: string, scope: string): SnapshotManifest | null {
  const filePath = manifestPath(cwd, scope)
  if (!fs.existsSync(filePath)) {
    return null
  }

  return JSON.parse(fs.readFileSync(filePath, 'utf-8')) as SnapshotManifest
}
